import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { MemoryGroup } from '@timelyapp/integration-cloud-api-spec';

export interface TicGlobalState {
  openMemoryConfig: MemoryGroup | null | 'global';
  /** Set false if TIC API/service are unreachable (e.g, maintenance) */
  ticServicesAreOnline: boolean;
}
const initialState: TicGlobalState = {
  openMemoryConfig: null,
  ticServicesAreOnline: true,
};

const ticGlobalSlice = createSlice({
  name: 'ticGlobal',
  initialState,
  reducers: {
    setOpenMemoryConfig: (
      state,
      { payload }: PayloadAction<TicGlobalState['openMemoryConfig']>
    ) => {
      state.openMemoryConfig = payload;
    },
    setTicServiceAsAvailable: (state, { payload }: PayloadAction<boolean>) => {
      state.ticServicesAreOnline = payload;
    },
  },
  selectors: {
    getOpenMemoryConfig: state => state.openMemoryConfig,
    getIsTicServiceOnline: state => state.ticServicesAreOnline,
  },
});

export const { setOpenMemoryConfig, setTicServiceAsAvailable } = ticGlobalSlice.actions;

export const { getOpenMemoryConfig, getIsTicServiceOnline } = ticGlobalSlice.selectors;

export default ticGlobalSlice.reducer;
